import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IVisaProcessingOption } from "../visaprocessingoptionModel";

export const getAllVisaProcessingOptions = createAsyncThunk(
  "VisaProcessingOptions/FindAllVisaProcessingOptions",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaProcessingOptions/FindAllVisaProcessingOptions`,
        {
          Type: "",
          Duration: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching VisaProcessingOptions:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveVisaProcessingOptions = createAsyncThunk(
  "VisaProcessingOptions/FindAllActiveVisaProcessingOptions",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/VisaProcessingOptions/FindAllActiveVisaProcessingOptions`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching VisaProcessingOptions:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createVisaProcessingOption = createAsyncThunk(
  "VisaProcessingOptions/InsertVisaProcessingOptions",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaProcessingOptions/InsertVisaProcessingOptions`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating VisaProcessingOption:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateVisaProcessingOption = createAsyncThunk(
  "VisaProcessingOptions/UpdateVisaProcessingOptions",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaProcessingOptions/UpdateVisaProcessingOptions`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating VisaProcessingOption:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getVisaProcessingOptionByID = createAsyncThunk(
  "VisaProcessingOptions/FindByIDVisaProcessingOptions",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaProcessingOptions/FindByIDVisaProcessingOptions`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result?.ID,
        VisaCountryID: result?.VisaCountryID ? +result?.VisaCountryID : null,
        VisaCountry: result?.VisaCountry,
        Type: result?.Type,
        Duration: result?.Duration,
        Description: result?.Description,
        Price: result?.Price ? +result?.Price : null,
        IsActive: result?.IsActive ? 1 : 2,
      } as IVisaProcessingOption;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching VisaProcessingOption:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const visaProcessingOptionActiveInactive = createAsyncThunk(
  "VisaProcessingOptions/ActiveInActiveVisaProcessingOptions",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaProcessingOptions/ActiveInActiveVisaProcessingOptions`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive VisaProcessingOption:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteVisaProcessingOption = createAsyncThunk(
  "VisaProcessingOptions/DeleteVisaProcessingOptions",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaProcessingOptions/DeleteVisaProcessingOptions`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting VisaProcessingOption:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
